<template>
  <div class="namespace-queues-page">
    <template v-if="!isLoading">
      <div v-if="queuesCards.length" style="width: 100%">
        <div class="namespace-queues-page__header">
          <h2 class="namespace-queues-page__title">Список очередей</h2>
          <div class="namespace-queues-page__settings">
            <TirPmButton
              :variant="TirPmButtonVariantEnum.LinkState"
              :size="TirPmButtonSizeEnum.Small"
              :isPressed="chooseSortName"
              @click="sortByNameQueue"
            >
              <template #rightSlot>
                <BarsArrowUpIcon v-if="stateSortName" />
                <BarsArrowDownIcon v-else />
              </template>
              По названию
            </TirPmButton>
            <TirPmButton
              :variant="TirPmButtonVariantEnum.LinkState"
              :size="TirPmButtonSizeEnum.Small"
              :isPressed="chooseSortCountTasks"
              @click="sortByCountTasksQueue"
            >
              <template #rightSlot>
                <BarsArrowUpIcon v-if="stateSortCountTasks" />
                <BarsArrowDownIcon v-else />
              </template>
              По количеству задач
            </TirPmButton>
            <TirPmPopover
              width="26.25rem"
              class="group-page__empty-popover"
              :position="PopoverPositionEnum.Bottom"
            >
              <template #default>
                <TirPmButton
                  class="tasks-kanban__header__add"
                  :variant="TirPmButtonVariantEnum.SecondaryState"
                  :size="TirPmButtonSizeEnum.Small"
                >
                  <template #leftSlot>
                    <PlusIcon />
                  </template>
                  <p>Создать очередь</p>
                </TirPmButton>
              </template>
              <template #content>
                <FormCreateQueue :namespaceId="namespaceId" @onCreate="onCreateQueue" />
              </template>
            </TirPmPopover>
          </div>
        </div>
        <TirPmScrollbar :style="{ maxHeight: 'calc(100vh - 15rem)' }" :show-on-hover="true">
          <div class="namespace-queues-page__list" style="margin-right: 0.5rem">
            <QueueCard v-for="queue in queuesCards" :key="queue.Id" :queue="queue" />
          </div>
        </TirPmScrollbar>
      </div>
      <div v-else class="namespace-queues-page__empty">
        <TirPmSystemMessage style="width: 26.25rem">
          <template #topDescImage>
            <div>
              <TirPmIconView :isBordered="false" style="width: 5rem; height: 5rem">
                <template #mainSlot>
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.7074 2.29298C12.3167 1.90234 11.6833 1.90234 11.2926 2.29298L8.20945 5.37585C7.81877 5.7665 7.81877 6.39986 8.20945 6.79051L11.2933 9.87405C11.684 10.2647 12.3174 10.2647 12.7081 9.87405L15.7913 6.79118C16.1819 6.40053 16.1819 5.76717 15.7913 5.37652L12.7074 2.29298Z"
                      fill="var(--neutral-70, #686C73)"
                    />
                    <path
                      d="M17.2071 8.20839C17.5978 7.81775 18.2312 7.81774 18.6219 8.20839L21.707 11.2932C22.0977 11.6838 22.0977 12.3172 21.707 12.7078L18.6226 15.7919C18.232 16.1825 17.5985 16.1825 17.2078 15.7919L14.1228 12.7071C13.7321 12.3165 13.7321 11.6831 14.1228 11.2925L17.2071 8.20839Z"
                      fill="var(--neutral-70, #686C73)"
                    />
                    <path
                      d="M12.7093 14.1242C12.3186 13.7336 11.6852 13.7336 11.2945 14.1242L8.20922 17.2092C7.81853 17.5999 7.81853 18.2332 8.20922 18.6239L11.2925 21.7069C11.6832 22.0976 12.3166 22.0976 12.7073 21.7069L15.7926 18.6219C16.1833 18.2313 16.1833 17.5979 15.7926 17.2073L12.7093 14.1242Z"
                      fill="var(--neutral-70, #686C73)"
                    />
                    <path
                      d="M5.37708 8.20888C5.76776 7.81823 6.40119 7.81823 6.79187 8.20888L9.87749 11.2942C10.2681 11.6849 10.2681 12.3182 9.87749 12.7089L6.79336 15.7927C6.40268 16.1834 5.76926 16.1834 5.37858 15.7927L2.29295 12.7074C1.90227 12.3167 1.90227 11.6834 2.29295 11.2927L5.37708 8.20888Z"
                      fill="var(--neutral-70, #686C73)"
                    />
                  </svg>
                </template>
              </TirPmIconView>
            </div>
          </template>
          <template #mainTitleSlot>В данной рабочей области еще нет очередей</template>
          <template #mainSubtitleSlot>Создайте очередь, чтобы добавить задачи</template>
          <template #descriptionSlot>Задачи могут содержаться только в очередях</template>
          <template #actionsSlot>
            <div class="namespace-queues-page__empty-buttons">
              <TirPmPopover
                width="26.25rem"
                style="width: 100%"
                :position="PopoverPositionEnum.Bottom"
              >
                <template #default>
                  <TirPmButton
                    class="namespace-queues-page__empty-button"
                    :variant="TirPmButtonVariantEnum.PrimaryState"
                    :size="TirPmButtonSizeEnum.Regular"
                    @click="viewQueueForm = true"
                  >
                    Создать очередь
                  </TirPmButton>
                </template>
                <template #content>
                  <FormCreateQueue :namespace-id="namespaceId" @on-create="onCreateQueue" />
                </template>
              </TirPmPopover>
              <TirPmPopover
                width="26.25rem"
                style="width: 100%"
                :position="PopoverPositionEnum.Bottom"
              >
                <template #default>
                  <TirPmButton
                    class="namespace-queues-page__empty-button"
                    :variant="TirPmButtonVariantEnum.SecondaryState"
                    :size="TirPmButtonSizeEnum.Regular"
                    @click="viewFolderForm = true"
                  >
                    Создать папку
                  </TirPmButton>
                </template>
                <template #content>
                  <SidebarAddPopoverFolderForm
                    :location="TreeItemType.Namespace"
                    :namespace-id="namespaceId"
                  />
                </template>
              </TirPmPopover>
            </div>
          </template>
        </TirPmSystemMessage>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import {
  DeleteQueueInfoModel,
  GroupModel,
  QueueModel,
  QueueTasksModel,
  UpdateQueueNameModel,
} from './models';
import { AdapterService } from './adapter';
import { FormCreateQueue, QueueCard, QueueCardtemModel } from '@/components';
import { pending } from './utils';
import { TirPmSystemMessage } from 'tir-pm-system-message';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmIconView,
  TirPmPopover,
  PopoverPositionEnum,
  TirPmScrollbar,
} from 'tir-components';
import { BarsArrowDownIcon, BarsArrowUpIcon, PlusIcon } from 'tir-style-system/icons/outline';
import SidebarAddPopoverFolderForm from '@/components/sidebar/components/sidebar-add-popover-folder-form.vue';
import { TreeItemType } from './enums';

const props = defineProps({
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  /**Событие смены видимости поповера */
  (e: 'toggleVisible', value: boolean): void;
}>();

const adapter = new AdapterService();

/**Загрузка */
const isLoading = ref(false);
/**Список очередей */
const queues = ref(new Array<QueueModel>());
/**Видимость формы создания папки */
const viewFolderForm = ref(false);
/**Видимость формы создания очереди */
const viewQueueForm = ref(false);
/**Состояние сортировки по названию */
const stateSortName = ref(true);
/**Состояние сортировки по кол-ву задач */
const stateSortCountTasks = ref(false);
/**Выбрана сортировка по названию */
const chooseSortName = ref(true);
/**Выбрана сортировка по кол-ву задач */
const chooseSortCountTasks = ref(false);

/**Список очередей в виде карточек */
const queuesCards = computed(() =>
  queues.value.map(
    (queue) =>
      new QueueCardtemModel({
        Id: queue.Id,
        Name: queue.Name,
        TasksCount: queue.TasksCount,
        ParentTask: queue.ParentTask,
      }),
  ),
);

watch(
  () => props.namespaceId,
  () => {
    getQueueList();
  },
);

/**Сортировать очереди по названию */
const sortByNameQueue = () => {
  if (stateSortName.value) {
    queues.value.sort((a, b) => a.Name.localeCompare(b.Name));
  } else {
    queues.value.sort((a, b) => b.Name.localeCompare(a.Name));
  }
  stateSortName.value = !stateSortName.value;
  stateSortCountTasks.value = true;
  chooseSortName.value = true;
  chooseSortCountTasks.value = false;
};

/**Сортировать очереди по кол-ву задач */
const sortByCountTasksQueue = () => {
  if (stateSortCountTasks.value) {
    queues.value.sort((a, b) => a.TasksCount - b.TasksCount);
  } else {
    queues.value.sort((a, b) => b.TasksCount - a.TasksCount);
  }
  stateSortCountTasks.value = !stateSortCountTasks.value;
  stateSortName.value = true;
  chooseSortName.value = false;
  chooseSortCountTasks.value = true;
};
/**Обновление очереди */
const onUpdateQueue = (_queue: UpdateQueueNameModel | QueueTasksModel) => {
  const currentQueue = queues.value.find(
    (queue) => queue.Id === (_queue as UpdateQueueNameModel).QueueId,
  );
  currentQueue.Name = _queue.Name;
};
/**Создание очереди */
const onCreateQueue = (_queue: QueueTasksModel) => {
  const queueId = _queue.Id;
  if (!queueId || !queues.value.some((queue) => queue.Id === queueId)) return;
  const queue = new QueueModel({
    Id: _queue.Id,
    Name: _queue.Name,
    NamespaceId: _queue.NamespaceId,
    TasksCount: _queue.TaskCount,
  });
  queues.value.push(queue);
};

/**Подписаться/отписаться на/от события */
const toggleEvents = (isSubscribe: boolean) => {
  const eventFnName = isSubscribe ? 'on' : 'removeListener';

  adapter.OnUpdateQueueName[eventFnName](onUpdateQueue);
  adapter.DeleteQueueEvent[eventFnName](onDeleteQueue);
  adapter.CreateQueueEvent[eventFnName](onCreateQueue);
};

/**При удалении очереди из сайдбара */
const onDeleteQueue = (e: DeleteQueueInfoModel) => {
  const queueId = e.QueueId;
  if (!queueId || !queues.value.some((queue) => queue.Id === queueId)) return;
  queues.value = queues.value.filter((queue) => queue.Id !== queueId);
};

const pendingGetQueueList = pending(async (namespaceId: string) => {
  const resp = await adapter.getQueueList(namespaceId, false);
  if (resp.IsSuccess) queues.value = resp.Value;
});

const getQueueList = async () => {
  isLoading.value = true;
  await pendingGetQueueList(props.namespaceId);
  isLoading.value = false;
};

/**После рендера компонента */
onMounted(async () => {
  await getQueueList();
  sortByNameQueue();
  toggleEvents(true);
});
/**После размонтирования комопнента */
onUnmounted(() => {
  toggleEvents(false);
});
</script>

<style lang="scss" scoped>
.namespace-queues-page {
  min-height: 100%;
  display: flex;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__settings {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  &__list {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
    margin-top: 0.75rem;
  }

  &__title {
    display: block;
    color: var(--text-primary, #272d37);
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25rem;
    margin: 0;
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }
  &__empty-buttons {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    width: 100%;
  }
  &__empty-button {
    width: 100%;
  }
  &__empty-popover {
    width: 100%;
  }
}
</style>
